import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Icon } from '../office-door-widget.model';

@Component({
  selector: "app-office-door-widget-choose-command-dialog",
  templateUrl: "./office-door-widget-choose-command-dialog.component.html",
  styleUrls: ["./office-door-widget-choose-command-dialog.component.scss"],
})
export class OfficeDoorWidgetChooseCommandDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<OfficeDoorWidgetChooseCommandDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public commands: Icon[],
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
  ) { 
    iconRegistry.addSvgIcon("lock",   sanitizer.bypassSecurityTrustResourceUrl("assets/img/icons/lock-locked.svg"));
    iconRegistry.addSvgIcon("unknown",  sanitizer.bypassSecurityTrustResourceUrl("assets/img/icons/lock-unknown.svg"));
    iconRegistry.addSvgIcon("unlock", sanitizer.bypassSecurityTrustResourceUrl("assets/img/icons/lock-unlocked.svg"));
  }
}
